import { useNavigate } from "@tanstack/react-router";
import { ExpenseBanner } from "@/components/expenses/ExpenseBanner";
import { useExpensePending } from "@/hooks/use-expenses";

/** "N expenses to approve · Review" on Home; nothing at 0. */
export function HomeExpenseBanner({ enabled }: { enabled: boolean }) {
  const navigate = useNavigate();
  const count = useExpensePending(enabled).data?.count ?? 0;
  return (
    <ExpenseBanner
      count={count}
      onReview={() => void navigate({ to: "/dashboard/expenses", search: { tab: "approvals" } })}
    />
  );
}
